import axios from "axios"
import {baseURL} from '@/config'
axios.defaults.baseURL = baseURL

export default axios